import { toEnglishNumber } from '@mofid-securities/uikit';

export const generateRandomString = (length: number = 16): string => {
  if (typeof length !== 'number') {
    throw new Error('invalid length. it must be type of number');
  } else if (length < 1) {
    throw new Error('invalid length. it must be greater than 1');
  }

  let string: string = '';
  for (let i = 0; i < length / 16; i++) {
    string +=
      new Date().getTime().toString(36) + Math.random().toString(36).slice(2);
  }

  return string
    .split('')
    .sort(() => (Math.random() > 0.5 ? 1 : -1))
    .join('')
    .slice(0, length);
};

export const toBoolean = (
  value: string | string[] | number | boolean | null | undefined
) => String(value).toLowerCase() === 'true';

export const extractCardNumberFromText = (text: string) => {
  const cardNumberRegEx = /\d{4}.?\d{4}.?\d{4}.?\d{4}/;

  // Converts persian numbers to english
  const convertedText = toEnglishNumber(text);

  const cardNumber = convertedText.match(cardNumberRegEx)?.[0];
  if (cardNumber) {
    return cardNumber.replace(/[^0-9]/g, '');
  }
  return null;
};

export const convertToGUID = (value: string) =>
  value.replace(
    /([0-z]{8})([0-z]{4})([0-z]{4})([0-z]{4})([0-z]{12})/,
    '$1-$2-$3-$4-$5'
  );

export const toFarsiNumber = (text: string | number) => {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const value = text || '';
  return value
    .toString()
    .replace(/\d/g, (x) => farsiDigits?.[x as unknown as number]);
};

export const isPhoneNumberValid = (value: string) => {
  const regex = new RegExp('^(\\+98|0)?9\\d{9}$');
  return regex.test(value);
};

export const changeStringDirection = (dir: 'rtl' | 'ltr', text: string) => {
  if (dir === 'rtl') return '\u202B' + text + '\u202C';
  return '\u202A' + text + '\u202C';
};

export const matchPattern = (
  url: string,
  patterns: { [key: string]: string }
): string | null => {
  for (const pattern in patterns) {
    // Modify the regex to match url or any path starting with `/url/something`
    const regexPattern = new RegExp(
      `^${pattern.replace(/\/\*$/, '(?:/.*)?')}$`
    );

    if (regexPattern.test(url)) {
      return patterns[pattern];
    }
  }
  return null;
};

export const isOnEnglishKeyboard = (value: string) => {
  if (value === '') return true;
  const regex = /^[~`!@#$%^&*()_+=[\]\{}|;':",.\/<>?a-zA-Z0-9-]+$/;
  return regex.test(value);
};

export const getStringPosition = (
  string: string,
  subString: string,
  index: number
): number => {
  return string.split(subString, index).join(' ').length;
};

export const convertArabicToPersian = (text: string) => {
  const arabicToPersianMap: Record<string, string> = {
    ي: 'ی', // Arabic Ya to Persian Ya
    ك: 'ک', // Arabic Kaf to Persian Kaf
    ە: 'ه', // Arabic Heh (Kurdi) to Persian Heh
    ة: 'ه', // Arabic Teh Marbuta to Persian Heh
    '٤': '۴', // Arabic 4 to Persian 4
    '٥': '۵', // Arabic 5 to Persian 5
    '٦': '۶', // Arabic 6 to Persian 6
  };

  return text.replace(
    /ي|ك|ە|ة|٤|٥|٦/g,
    (match) => arabicToPersianMap[match] || match
  );
};

export const replaceIRFromIban = (iban: string, replaceWith: string = '') => {
  return iban.replace('IR', replaceWith);
};
